import NR1DashboardsHub from "@/pages/NR1DashboardsHub";

export default function DashboardsHubSalvia() {
  return <NR1DashboardsHub forcedVariant="salvia" />;
}
